<template>
  <DModal
    :show-close="false"
    :isBgOverlay="true"
    @close="$emit('close')"
    :appendToBody="true"
    style="z-index: 12312312312312"
  >
    <div class="d-modal" id="d-create-task-for-user" slot="insertComponent" @click.stop>
      <div class="d-modal__header">
        <h2 v-if="isEditing">Redigér</h2>
        <h2 v-else>Opret</h2>
        <div class="font-large icon__bg-circle d-modal__header__close" @click="$emit('close')">
          <span class="icon-cross2"></span>
        </div>
      </div>

      <div class="d-modal__content">
        <div class="d-input-group">
          <label class="d-label">Navn</label>
          <input
           ref="input_title"
            type="text"
            class="d-input"
            v-model="name"
            :placeholder="placeholder1"
            @keydown.enter="onSubmit"
          />
        </div>
          <div class="d-input-group">
            <label class="d-label">{{ theType === 'omkostningssteder' ? 'Kode' : 'Lønart' }}</label>
            <input
              type="text"
              class="d-input"
              :class="{'d-input--invalid': showCodeError}"
              v-model="code"
              :placeholder="placeholder2"
              @blur="touched.code = true"
              @keydown.enter="onSubmit"
            />
            <p class="field-error" v-if="showCodeError">{{ codeError }}</p>
          </div>
          <div class="d-input-group" v-if="isSalaryCode">
            <label class="d-label">Tillægsnummer <span class="d-label__optional">(valgfrit)</span></label>
            <input
              type="text"
              class="d-input"
              :class="{'d-input--invalid': showTillaegsnummerError}"
              ref="input_tillaegsnummer"
              v-model="tillaegsnummer"
              @blur="touched.tillaegsnummer = true"
              @keydown.enter="onSubmit"
            />
            <p class="field-error" v-if="showTillaegsnummerError">{{ tillaegsnummerError }}</p>
            <p class="field-help" v-if="tillaegsnummerHelp">{{ tillaegsnummerHelp }}</p>
          </div>
          <p class="submit-error" v-if="submitError">{{ submitError }}</p>
      </div>

      <div class="d-modal__buttons">
          <button class="do-bttn" @click="$emit('close')">
            {{ $t('vue2.common.cancel') }}
          </button>
          <button
            class="do-bttn do-bttn--submit"
            :class="{
              'do-bttn--submit--disabled': !isValid || isSubmitting,
              'do-bttn--submit--loading': isSubmitting
            }"
            @click="onSubmit"
          >
            {{ isEditing ? 'Opdatér' : 'Opret' }}
          </button>
        </div>
    </div>
  </DModal>
</template>

<script>
import DModal from '../../common/DModal.vue'
// import docendo from '../../../docendo'
// import eventbus from '../../../eventbus'

export default {
  name: 'SalaryRuleCostCentersCreateModal',
  components: {DModal},
  props: {
    theType: {
      type: String,
      default: 'lønkoder' // 'omkostningssteder' | 'lønkoder'
    },
    placeholder1: {
      type: String,
      default: ''
    },
    placeholder2: {
      type: String,
      default: ''
    },
    theEditItem: {
      type: Object,
      default: null // ex { name: 'Vest', code: '54321' }
    },
    isSubmitting: {
      type: Boolean,
      default: false
    },
    isDeleting: {
      type: Boolean,
      default: false
    },
    // Kun relevant for theType 'lønkoder': 'SD' | 'KMD' (skolens lønsystem)
    salarySystem: {
      type: String,
      default: null
    },
    // Fejlbesked fra API'et (vises i dialogen)
    submitError: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      name: '',
      code: '',
      tillaegsnummer: '',
      touched: {code: false, tillaegsnummer: false},
      isSubmitAttempted: false
    }
  },
  computed: {
    isEditing () {
      return !!this.theEditItem
    },
    schoolId () {
      return this.$store.getters.schoolId
    },
    isSalaryCode () {
      return this.theType === 'lønkoder'
    },
    trimmedCode () {
      return String(this.code).trim()
    },
    trimmedTillaegsnummer () {
      return String(this.tillaegsnummer).trim()
    },
    // Spejler valideringen i backend (app/models/salary/code.rb)
    codeError () {
      if (!this.isSalaryCode) {
        return ''
      }
      return /^\d{3}$/.test(this.trimmedCode) ? '' : 'Lønart skal være præcis 3 cifre'
    },
    tillaegsnummerError () {
      if (!this.isSalaryCode || this.trimmedTillaegsnummer === '') {
        return ''
      }
      if (this.salarySystem === 'SD' && !/^\d{6}$/.test(this.trimmedTillaegsnummer)) {
        return 'Tillægsnummer skal være 6 cifre eller tomt'
      }
      if (this.salarySystem === 'KMD' && !/^\d$/.test(this.trimmedTillaegsnummer)) {
        return 'Tillægsnummer skal være 1 ciffer eller tomt'
      }
      return ''
    },
    tillaegsnummerHelp () {
      if (this.salarySystem === 'SD') {
        return 'Kun til faste månedlige tillæg. 6 cifre, fx 111122. Lad feltet stå tomt for timebaserede lønarter.'
      }
      if (this.salarySystem === 'KMD') {
        return 'Kun til faste månedlige tillæg. 1 ciffer (løbenummer), fx 1. Lad feltet stå tomt for timebaserede lønarter.'
      }
      return ''
    },
    showCodeError () {
      return !!this.codeError && (this.touched.code || this.isSubmitAttempted)
    },
    showTillaegsnummerError () {
      return !!this.tillaegsnummerError && (this.touched.tillaegsnummer || this.isSubmitAttempted)
    },
    isValid () {
      const hasNameAndCode = this.name.trim().length > 0 && this.trimmedCode.length > 0
      if (this.isSalaryCode) {
        // Tillægsnummer er valgfrit, men skal have korrekt format hvis det udfyldes
        return hasNameAndCode && !this.codeError && !this.tillaegsnummerError
      }
      return hasNameAndCode
    }
  },
  methods: {
    onSubmit () {
      this.isSubmitAttempted = true
      if (!this.isValid || this.isSubmitting) {
        return
      }
      let obj = {
        name: this.isSalaryCode ? this.name.trim() : this.name,
        code: this.isSalaryCode ? this.trimmedCode : this.code
      }
      if (this.isSalaryCode && this.trimmedTillaegsnummer.length > 0) {
        obj.tillaegsnummer = this.trimmedTillaegsnummer
      }
      this.$emit('onSubmit', obj)
    }
  },
  beforeMount () {
    if (this.theEditItem) {
      const t = this.theEditItem
      this.name = t.name ? String(t.name) : ''
      this.code = t.code !== undefined && t.code !== null ? String(t.code) : ''
      this.tillaegsnummer = t.tillaegsnummer !== undefined && t.tillaegsnummer !== null ? String(t.tillaegsnummer) : ''
    }
  },
  mounted () {
    this.$nextTick(_ => {
      const el = this.$refs.input_title
      if (el) el.focus()
    })
  }
}
</script>

<style scoped>
@import "../../../assets/css/variables.css";

.d-modal {
  width: 500px;
  border-radius: 16px;
  position: relative;
}

.d-modal__header {
  margin-bottom: 0;
  text-align: left;
}

.d-modal__buttons {
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
  padding: 1rem 2rem;
}

.d-modal__content {
  padding: 1rem;
}

.d-input-group--toggler {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #fff;
  padding: 1rem;
  border-radius: 4px;
  cursor: pointer;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, .1), 0 1px 2px -1px rgba(0, 0, 0, .1);
}

.d-input-group--toggler.d-input-group--toggler--active > .d-label {
  color: var(--dark-blue);
}

.d-input-group--toggler > .d-label {
  margin-bottom: 0;
  cursor: pointer;
}

.d-input-group--toggler:hover {
  background: #f0f8ff;
}

.d-input-group .d-input {
  height: 34px;
}

.d-input-group .d-input.d-input--invalid {
  border-color: #d9534f;
}

.d-label__optional {
  font-weight: normal;
  text-transform: none;
  opacity: 0.7;
}

.field-error,
.submit-error {
  color: #d9534f;
  font-size: 0.85rem;
  margin: 0.25rem 0 0;
}

.field-help {
  color: #6b7280;
  font-size: 0.85rem;
  margin: 0.25rem 0 0;
}

.d-input-group {
  margin-bottom: 1rem;
}

.d-input-group-flex {
  display: flex;
  padding: 0 1rem;
  gap: 1rem;
}

.d-input-group-flex > div {
  flex: 1;
}

.d-input-group-flex label.d-label {
  margin-bottom: 0.25rem;
}
</style>



// WEBPACK FOOTER //
// TableCreateModal.vue?72bd0886